<template>
  <div class="ac-card-content">
    <div class="ac-body-container">
      <img
        src="@shared/assets/img/logo/smart-maintenance-grey.png"
        class="ac-logo"
        alt="Smart Maintenance®"
      >
      <div class="ac-header">
        Smart Maintenance® Plan Details
      </div>
      <div class="ac-plan-container">
        <div class="ac-plan-header">
          <img
            src="@shared/assets/img/setting/cc-full-icon.svg"
            alt="Comfort Credits"
          >
          Comfort Credits
        </div>
        <div class="ac-plan-body">
          Customize special offers when homeowners sign up for
          maintenance plans. Credits can also accumulate over time,
          encouraging customer loyalty.
        </div>
      </div>
      <button
        class="ac-button"
        @click="close"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComfortCreditInfo',
  props: {
    close: Function,
  },
};
</script>
